var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useContext } from "react";
import { BigNumber } from "ethers";
import { CHAINS_TO_ID, isSolanaVault, VaultAddressMap, VaultList, VaultVersionList, } from "../constants/constants";
import { SubgraphDataContext } from "./subgraphDataContext";
import { isEVMChain, isSolanaChain } from "../utils/chains";
var getVaultActivityKey = function (vault, type) { return "vaultActivity_" + type + "_" + vault.replace(/-/g, ""); };
export var vaultActivitiesGraphql = function (version, chain) {
    return VaultList.reduce(function (acc, vault) {
        var vaultAddress = VaultAddressMap[vault][version];
        if (!isSolanaVault(vault) &&
            (!vaultAddress || VaultAddressMap[vault].chainId !== CHAINS_TO_ID[chain])) {
            return acc;
        }
        if (isEVMChain(chain)) {
            vaultAddress = vaultAddress === null || vaultAddress === void 0 ? void 0 : vaultAddress.toLowerCase();
        }
        return (acc +
            ("\n          " + getVaultActivityKey(vault, "shortPositions") + ":\n          vaultShortPositions\n          " + (isSolanaChain(chain)
                ? "(where: { vaultId: {_in: [\"" + vaultAddress + "\"] }})"
                : "(where: { vault_in: [\"" + vaultAddress + "\"] })") + "\n          {\n            id\n            depositAmount\n            mintAmount\n            strikePrice\n            openedAt\n            openTxhash\n            expiry\n          }\n\n          " + getVaultActivityKey(vault, "optionTrades") + ":\n          vaultOptionTrades " + (isSolanaChain(chain)
                ? "(where: { vaultId: {_in: [\"" + vaultAddress + "\"] }})"
                : "(where: { vault_in: [\"" + vaultAddress + "\"] })") + "\n          {\n            vaultShortPosition {\n              id\n              strikePrice\n              expiry\n            }\n            sellAmount\n            premium\n            timestamp\n            txhash\n          }\n        "));
    }, "");
};
// console.log("VaultList:", VaultList)
export var resolveVaultActivitiesSubgraphResponse = function (responses) {
    return Object.fromEntries(VaultVersionList.map(function (version) { return [
        version,
        Object.fromEntries(VaultList.map(function (vault) {
            var shortPositionsData = responses[version]
                ? responses[version][getVaultActivityKey(vault, "shortPositions")] || []
                : [];
            var optionTradesData = responses[version]
                ? responses[version][getVaultActivityKey(vault, "optionTrades")] ||
                    []
                : [];
            return [
                vault,
                __spreadArray(__spreadArray([], shortPositionsData.map(function (item) { return (__assign(__assign({}, item), { depositAmount: BigNumber.from(item.depositAmount), mintAmount: BigNumber.from(item.mintAmount), strikePrice: BigNumber.from(item.strikePrice), date: new Date(item.openedAt * 1000), type: "minting" })); })), optionTradesData.map(function (item) { return (__assign(__assign({}, item), { vaultShortPosition: __assign(__assign({}, item.vaultShortPosition), { strikePrice: BigNumber.from(item.vaultShortPosition.strikePrice) }), sellAmount: BigNumber.from(item.sellAmount), premium: BigNumber.from(item.premium), date: new Date(item.timestamp * 1000), type: "sales" })); })),
            ];
        })),
    ]; }));
};
export var useAllVaultActivities = function () {
    var contextData = useContext(SubgraphDataContext);
    // console.log('loading useAllVaultActivities:', contextData.vaultSubgraphData.loading)
    return {
        activities: contextData.vaultSubgraphData.vaultActivities,
        loading: contextData.vaultSubgraphData.loading,
    };
};
var useVaultActivity = function (vault, vaultVersion) {
    if (vaultVersion === void 0) { vaultVersion = "v1"; }
    var contextData = useContext(SubgraphDataContext);
    // console.group('SubgraphData')
    // console.log(contextData.vaultSubgraphData)
    // console.groupEnd()
    return {
        activities: contextData.vaultSubgraphData.vaultActivities[vaultVersion][vault],
        loading: contextData.vaultSubgraphData.loading,
    };
};
export default useVaultActivity;
//# sourceMappingURL=useVaultActivity.js.map